// A sub project (SubProjectDTO) of a registry project. Several sub projects can share a language,
// so they are always told apart by id and shown by name plus language.

export const subProjectLanguage = (subProject) => subProject?.languageName || subProject?.languageCode || "";

// "Support · English"; just the name when the name already is the language (the default name)
export const subProjectLabel = (subProject) => {
  if (!subProject) return "";
  const name = subProject.name || subProjectLanguage(subProject);
  const language = subProjectLanguage(subProject);
  return language && language.toLowerCase() !== name.toLowerCase() ? `${name} · ${language}` : name;
};
